import { Center, Image } from '@chakra-ui/react';

import logo from '../../resources/images/logo_sm.png';

export const Header = () => {
  return (
    <Center as="header" style={{ borderBottom: '8px solid #2B6CB0' }}>
      <Image src={logo} alt="日本ガスロゴ" height={24} />
    </Center>
  );
};
